import { DynamicFormAnswer } from '@api_patient/dynamic_forms_api.service';
import { CellulaFormSubmitData } from '@cellula/react';
import type { QuestionApiModel } from '@visiba/api-vcs-client-v2';
import { FormOption, ValidOptionId } from './_form_option';
import { FormQuestionBase } from './_form_question_base';

export class FormQuestionTypeSingleChoiceSelect extends FormQuestionBase {
	public readonly type = 'SingleChoiceSelect';
	public readonly options: FormOption[];
	public defaultValue: ValidOptionId | undefined = undefined;

	constructor(question: QuestionApiModel) {
		super(question);

		// TODO PAT-426: Allow null?
		this.options = this.parseQuestions(question.Options ?? []);
	}

	// TODO: Use this when not injected anymore...
	public getAnswer(pageData: CellulaFormSubmitData): DynamicFormAnswer {
		// public override getAnswer(formElements: FormElements<string>): AnswerApiModel {
		const formValue = pageData[this.id] ?? null;
		const option =
			formValue != null
				? this.options.find((option) => option.composeOptionId(formValue as ValidOptionId) === option.composeOptionId())
				: null;

		return this.createAnswerApiModel({
			choices: option != null ? [option.composeOptionId()] : [],
		});
	}

	// TODO: Use this when not injected anymore...
	// public override setDefault(allAnswers: Readonly<AnswerApiModel[]>): void {
	public setDefault(allAnswers: Readonly<DynamicFormAnswer[]>): void {
		const answer = allAnswers.find((answer) => answer.questionId === this.composeQuestionId());

		let defaultValue: ValidOptionId | undefined = undefined;

		// PAT-593
		// Allowing old data to still be displayed before migrating to how it actually should be stored as.
		// TODO @emilnordling: This condition can be removed in the future.
		if (answer?.intValue != null) {
			defaultValue = FormOption.parseOptionId(answer.intValue);
		}

		if (answer?.choices != null && answer.choices[0] != null) {
			defaultValue = FormOption.parseOptionId(answer.choices[0]);
		}

		this.defaultValue = defaultValue;
	}
}
